import React from 'react';

import { Form, Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import Label from 'components/shared/FormAdapters/FormDefault/Label';
import LabelWrapper from 'components/shared/FormAdapters/FormDefault/Label/Wrapper';
import Loader from 'components/shared/Loader';
import StickyFooter from 'components/shared/StickyFooter/StickyFooter';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import UnsavedChangesFormWatcher from 'components/shared/UnsavedChangesFormWatcher';
import useElementBottomPosition, { SNACKBAR_POSITION } from 'hooks/useElementBottomPosition';
import { pageDataSelector } from 'store/page/selectors';
import { capitalizeAllWordsForInput } from 'utils/common';
import generateHandleValue from 'utils/form/mutators/generateHandleValue';

import { BuilderFooterButton } from '../../shared/BuilderFooterButton';
import { usePageContext } from '../../shared/context';
import PageFormButtons from '../../shared/PageFormButtons';
import { useHandleAfterNextDetails } from '../../utils';
import { useNoteAboutSafariDetails } from './functions';

function Details() {
  useElementBottomPosition(SNACKBAR_POSITION);
  const page = useSelector(pageDataSelector);
  const { useNextStepFormHandler } = usePageContext();
  const onAfterNext = useHandleAfterNextDetails();
  const handleNextStep = useNextStepFormHandler({ onAfterNext });
  const { validate } = useNoteAboutSafariDetails();

  return (
    <Form
      onSubmit={async (values) => {
        try {
          await handleNextStep(values);
        } catch (e) {
          console.error('----- handleNextStep e', e);
        }
      }}
      initialValues={page}
      validate={validate}
      mutators={{
        generateHandleValue,
      }}
      render={({
        handleSubmit,
        submitting,
        invalid,
        values,
        form: {
          mutators: { generateHandleValue },
        },
      }) => (
        <form onSubmit={handleSubmit} autoComplete="nope">
          <UnsavedChangesFormWatcher />

          {submitting && <Loader isFillBlock />}
          <FormTitle center>{page.id ? 'Edit Page Content' : 'Create New Content'}</FormTitle>

          <FormTitle hint="Enter information to organize this content so that you can find it easily later.">
            I. Page Details
          </FormTitle>

          <Field
            component={FormGroupAdapter}
            name="name"
            placeholder="kenya and rwanda"
            type="text"
            label="Page Name*"
            onCustomChange={generateHandleValue}
            onInput={capitalizeAllWordsForInput}
          />

          <LabelWrapper>
            <Label>Tags</Label>
            <Text accent>Use tags to remind yourself what this page is about.</Text>
          </LabelWrapper>

          <Field
            component={FormGroupAdapter}
            name="tags"
            placeholder="lewa, mara, gorillas, honeymooners"
            type="tags"
            onCustomChange={generateHandleValue}
            disabled={values?.tags?.length > 2}
          />

          <LabelWrapper>
            <Label>@Handle</Label>
            <Text accent>Automatically generated from combining the name and tag fields.</Text>
          </LabelWrapper>

          <Field
            component={FormGroupAdapter}
            name="handle"
            placeholder="@LewaandMaraforHoneymooners"
            type="text"
            readOnly
          />

          <StickyFooter>
            <FormActions isRight>
              <BuilderFooterButton htmlType="submit" disabled={submitting || invalid}>
                Next
              </BuilderFooterButton>
            </FormActions>
          </StickyFooter>

          <PageFormButtons />
        </form>
      )}
    />
  );
}

export default Details;
